var render = function render(){var _vm=this,_c=_vm._self._c;return _c('signing-docs',{attrs:{"action":"cc-auth"}})
}
var staticRenderFns = []

export { render, staticRenderFns }